/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from 'react';
import { useFormikContext } from 'formik';
import { Chips, SelectGeneric, Loader } from 'ypf-pas-general-ui-components';

import { postReceivers } from '../../services/yclickMaster';
import {
  getMonthlyCommunicateTo,
  putMonthlyCommunicateTo
} from '../../services/monthlyServiceRequest';
import LoaderContext from '../../context/LoaderProvider';
import { CommunicateToPermissions } from '../MonthlyServiceRequest/RequestDetailTypes';
import { statusEnum } from '../../utils/dataStatus';
import { DetailRequestMonthly, DetailRequestMonthlyDefaultProp } from '../../utils/globalPropTypes';

import './MonthlyCommunicateTo.scss';

const MonthlyCommunicateTo = ({ details, communicateToPermissions }) => {
  const { values, setFieldValue, setFieldTouched, errors, touched } = useFormikContext();
  const { setLoader } = useContext(LoaderContext);

  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [defaultReceivers, setDefaultReceivers] = useState([]);
  const [inspectors, setInspectors] = useState([]);
  const stateCancelOrFinish =
    details.estadoEnum === statusEnum.cancelada || details.estadoEnum === statusEnum.finalizada;

  const fetchDefaultReceivers = async () => {
    const response = await getMonthlyCommunicateTo(details.id);
    const receiversResponse = response.destinatarioComunicarA.map((receivers) => ({
      label: receivers.nombre
    }));

    const adaptedInspectors = response.inspectores.map((i) => ({
      label: i.nombre
    }));

    setInspectors(adaptedInspectors);

    setDefaultReceivers(receiversResponse);
    const destinatarios = response.destinatarioConCopia.map((destinatario) => ({
      id: destinatario.id,
      nombre: destinatario.nombre,
      label: destinatario.nombre,
      value: destinatario.id
    }));

    setFieldValue('communicate.aditionalReceivers', destinatarios);
  };
  const updateReceivers = async (val) => {
    await putMonthlyCommunicateTo(val, details.id);
  };
  const fetchAditionalReceivers = async (val) => {
    if (val.length < 3) return null;
    // eslint-disable-next-line react/prop-types
    const businessUnitId = details.unidadNegocio.map((unidadNegocio) => unidadNegocio.id);

    // const businessUnitId = details.unidadNegocio.id;
    const response = await postReceivers(businessUnitId, val);

    return response;
  };

  useEffect(() => {
    setLoader(true);
    fetchDefaultReceivers()
      .then(() => setLoader(false))
      .catch(() => setLoader(false));
  }, [values?.provider?.providers]);

  return (
    <>
      <div className="d-flex align-items-center mb-2">
        <h6 className="me-3">Inspector:</h6>
        <Chips data={inspectors || []} variant="info" />
      </div>
      <div className="d-flex align-items-center">
        <h6 className="me-2">Comunicar a:</h6>
        <Chips data={defaultReceivers || []} variant="info" />
      </div>
      <hr />
      <div
        className={`monthly-communicate-to mt-3 ${
          stateCancelOrFinish || !communicateToPermissions.write ? 'read-only' : ''
        }`}
      >
        <SelectGeneric
          async
          errors={errors?.communicate?.aditionalReceivers}
          fetchData={(value) => fetchAditionalReceivers(value)}
          isDisabled={stateCancelOrFinish || !communicateToPermissions.write}
          isInvalid={
            errors?.communicate?.aditionalReceivers && touched?.communicate?.aditionalReceivers
              ? !!touched?.communicate?.aditionalReceivers &&
                !!errors?.communicate?.aditionalReceivers
              : false
          }
          isMulti
          label="Con copia a:"
          name="communicate.aditionalReceivers"
          onChange={async (val) => {
            try {
              setLoadingUpdate(true);
              await updateReceivers(val);
              await setFieldValue('communicate.aditionalReceivers', val);
              await setFieldTouched('communicate.aditionalReceivers');
              setLoadingUpdate(false);
            } catch (e) {
              setLoadingUpdate(false);
            }
          }}
          placeholder="Buscar por nombre o grupo"
          value={values?.communicate?.aditionalReceivers}
          variantOptions="info"
          withSelect="100%"
        />
        <Loader show={loadingUpdate} text="Cargando" />
      </div>
    </>
  );
};

MonthlyCommunicateTo.propTypes = {
  communicateToPermissions: CommunicateToPermissions.isRequired,
  details: DetailRequestMonthly
};
MonthlyCommunicateTo.defaultProps = {
  details: DetailRequestMonthlyDefaultProp
};

export default MonthlyCommunicateTo;
